import React, { memo, useEffect, useState } from 'react';

import Snackbar from '@material-ui/core/Snackbar';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';

import { Alert } from '../alert/Alert';
import { useStyles } from './Message.styles';
import { MessageProps } from './Message.types';

/**
 * Displays notifications as Snackbars with different severity styles
 */
export const Message = memo(({ type, text, autoClose, onClose, className, id }: MessageProps) => {
  const styles = useStyles();
  const [openSnackbar, setOpenSnackbar] = useState(false);

  /**
   * Handles closing the snackbar
   *
   * @param {React.SyntheticEvent} [event] - The event that triggered the close
   * @param {string} [reason] - Reason for closing
   */
  const handleCloseSnackbar = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false);
    if (onClose) {
      onClose(id);
    }
  };

  useEffect(() => {
    setOpenSnackbar(true);
  }, [text]);

  return (
    <Snackbar
      className={clsx(styles.snackbar, !!className && className)}
      open={openSnackbar}
      autoHideDuration={autoClose ? 6000 : null}
      onClose={handleCloseSnackbar}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert icon={false} severity={type} onClose={handleCloseSnackbar} className={styles.alert}>
        <Typography variant="h5" color="inherit">
          {text}
        </Typography>
      </Alert>
    </Snackbar>
  );
});
